import React from "react";
import {
  FaTwitter,
  FaFacebookF,
  FaInstagramSquare,
  FaTelegram,
  FaLinkedin,
} from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.footerContainer}>
        <div style={styles.footerColumn}>
          <h3 style={styles.header}>Subscribe</h3>
          <input
            type="email"
            placeholder="Your email"
            style={styles.footerInput}
          />
          <button style={styles.subscribeButton}>
            Subscribe to our Newsletter
          </button>
          <div>
            <h4 style={styles.connectUs}>Connect Us</h4>
            <div style={styles.socialIcons}>
              <a
                href="https://twitter.com/gess_knust"
                aria-label="Twitter"
                style={styles.icon}
              >
                <FaTwitter />
              </a>
              <a
                href="https://www.facebook.com/share/15ix2TVJKE/"
                aria-label="Facebook"
                style={styles.icon}
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com/gessknust_official"
                aria-label="Instagram"
                style={styles.icon}
              >
                <FaInstagramSquare />
              </a>
              <a
                href="https://t.me/gess_knust"
                aria-label="Telegram"
                style={styles.icon}
              >
                <FaTelegram />
              </a>
              <a
                href="https://www.linkedin.com/in/geological-engineering-students-society-knust"
                aria-label="LinkedIn"
                style={styles.icon}
              >
                <FaLinkedin />
              </a>
              <a
                href="mailto:geologicaleng@knust.edu.gh"
                aria-label="Email"
                style={styles.icon}
              >
                <BiLogoGmail />
              </a>
            </div>
          </div>
        </div>
        <div style={styles.footerColumn}>
          <h3 style={styles.header}>Contact Us</h3>
          <ul style={styles.list}>
            <p>Dept. of Geological Engineering.</p>
            <a href="#" style={styles.link}>
              College of Engineering KNUST, PMB
            </a>
            <a href="#" style={styles.link}>
              Kumasi-Ghana
            </a>
            <a href="#" style={styles.link}>
              Telephone: +233 322 060 156
            </a>
            <p style={styles.link}>Fax: +233 3220 60217</p>
            <p>
              Email:{" "}
              <a
                href="mailto:geologicaleng@knust.edu.gh"
                style={styles.link}
              >
                geologicaleng@knust.edu.gh
              </a>
            </p>
          </ul>
        </div>
        <div style={styles.footerColumn}>
          <h3 style={styles.header}>The Department</h3>
          <ul style={styles.list}>
            <li>
              <a href="#" style={styles.link}>
                About Us
              </a>
            </li>
            <li>
              <a href="#" style={styles.link}>
                Academic Calendar
              </a>
            </li>
            <li>
              <a href="#" style={styles.link}>
                Semester Events
              </a>
            </li>
            <li>
              <a href="#" style={styles.link}>
                Articles
              </a>
            </li>
            <li>
              <a href="#" style={styles.link}>
                Articles
              </a>
            </li>
          </ul>
        </div>
        <div style={styles.footerColumn}>
          <h3 style={styles.header}>GESS Support</h3>
          <p>
          Support the department's growth and initiatives by contributing through the website's donation section—every contribution makes a difference!
          </p>
          <button style={styles.donateButton}>Donate</button>
        </div>
      </div>
      <div style={styles.footerBottom}>
        <p>
          © 2024 Geological Engineering Students Society, KNUST, Kumasi, Ghana.
        </p>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: "rgba(13, 44, 62, 0.8)", // Reduced opacity for background color
    color: "#fff",
    padding: "20px 40px",
    backgroundImage: "url('/assets/images/GE2.jpg')", // Insert your image path here
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  footerContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  footerColumn: {
    flex: 1,
    margin: "10px",
    minWidth: "200px",
  },
  header: {
    fontSize: "18px",
    marginBottom: "15px",
  },
  connectUs: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "10px",
    textDecoration: "none",
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  footerInput: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    border: "1px solid white",
    borderRadius: "none",
  },
  subscribeButton: {
    backgroundColor: "transparent",
    color: "#fff",
    border: "1px solid white",
    padding: "10px 15px",
    borderRadius: "none",
    cursor: "pointer",
  },
  socialIcons: {
    display: "flex",
    marginTop: "10px",
  },
  icon: {
    margin: "0 5px",
    color: "#fff",
    fontSize: "20px",
    transition: "color 0.3s ease",
  },
  list: {
    listStyle: "none",
    padding: 0,
  },
  link: {
    color: "#fff",
    textDecoration: "none",
    display: "block",
    marginBottom: "5px",
    transition: "text-decoration 0.3s ease",
  },
  donateButton: {
    backgroundColor: "transparent",
    color: "#fff",
    border: "1px solid white",
    padding: "2px 15px",
    borderRadius: "none",
    cursor: "pointer",
    marginTop: "10px",
  },
  footerBottom: {
    textAlign: "center",
    marginTop: "20px",
    fontSize: "14px",
    borderTop: "1px solid #ccc",
    paddingTop: "10px",
  },
};

export default Footer;
